import { Input } from 'antd';
import CreateAntField from './CreateAntField';

const AntTextArea = CreateAntField(Input.TextArea);
const AntInput = CreateAntField(Input);
export { AntTextArea };
export default AntInput;
